import { FC } from 'react';
import { useUserContext } from '../../../providers/UserProvider';
import { StarIcon } from '../../shared/SVG/Icons/StarIcon';
import { useTranslations } from '../../../hooks/useTranslationsHelper';
import './ItvStarBalance.scss';

export const ItvStarBalance: FC = () => {
  const { t } = useTranslations();
  const {
    starBalance: { string: stringBalance },
  } = useUserContext();

  return (
    <div className="itv-balance">
      {stringBalance === '' ? (
        '...'
      ) : (
        <div className="itv-balance__content">
          <span className="itv-balance__text">{t('shop.starts-text')}:</span>
          <span className="itv-balance__value">{stringBalance}</span>
          <StarIcon />
        </div>
      )}
    </div>
  );
};
